<template>
  <div
    v-intersect="{
      handler: onIntersect,
      options: {
        rootMargin: `-${rm}px`,
        threshold: [0, 0.01, 1],
      },
    }"
  >
    <slot />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'intersection-div',
  data: () => ({
    tm: null,
    lastGone: false,
    tripScrollY: 0,
  }),
  props: { rm: { default: 100 }, dontUseStore: { default: false } },
  methods: {
    ...mapMutations(['setTitleGone']),
    scrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0
    },
    measureGone() {
      const el = this.$el
      if (!el) return this.lastGone
      const rm = Number(this.rm) || 0
      const rect = el.getBoundingClientRect()
      // совпадает с rootMargin: видимая зона уменьшена сверху/снизу на rm
      return !(rect.bottom > rm && rect.top < window.innerHeight - rm)
    },
    commit(isTitleGone) {
      if (isTitleGone === this.lastGone) return
      this.lastGone = isTitleGone
      if (isTitleGone) this.tripScrollY = this.scrollY()
      if (!this.dontUseStore) this.setTitleGone(isTitleGone)
      this.$emit('gone', isTitleGone)
    },
    onIntersect(entries /*, observer*/) {
      // Ловим уход маркера за экран для компактного sticky.
      // Важно: нельзя сразу доверять isIntersecting после смены высоты layout —
      // иначе зацикливается. См. measureGone + гистерезис по scrollY.
      const nextGone = !entries[0].isIntersecting
      if (nextGone === this.lastGone) return

      clearTimeout(this.tm)
      const delay = nextGone ? 0 : 160
      this.tm = setTimeout(() => {
        this.tm = null
        const settledGone = this.measureGone()
        if (settledGone === this.lastGone) return

        if (!settledGone && this.lastGone) {
          // Назад только если реально проскроллили вверх от точки срабатывания.
          // У самого верха страницы гистерезис не применяем — иначе hasTitleGone
          // может остаться true навсегда (tripScrollY < hysteresis).
          const y = this.scrollY()
          const hysteresis = Math.max(48, Number(this.rm) || 0)
          if (y > hysteresis && y > this.tripScrollY - hysteresis) return
        }

        this.commit(settledGone)
      }, delay)
    },
  },
  destroyed() {
    if (this.tm) clearTimeout(this.tm)
    this.lastGone = false
    if (!this.dontUseStore) this.setTitleGone(false)
    this.$emit('gone', false)
  },
}
</script>
